import React, { Component } from "react";
import { Tabs } from "antd";
import { connect } from "dva";
import Container from "../../../../../components/Container";
import IframeContainer from "../../Components/IframeContainer";
import { GetQueryString } from "../../../../../utils/utils";
import SummaryStatisticList from "./List";
import {
  getBureauSummaryList,
  getSchoolSummaryList
} from "../../../../../services/activitySign/dataStatistic/summaryStatistic";

const { TabPane } = Tabs;

@connect(({ user }) => ({
  ...user
}))
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nowTabKey: "1"
    };
    this.activityBizId = GetQueryString("activityBizId");
  }

  // tab更改
  handleChangeTab = key => {
    this.setState({
      nowTabKey: key
    });
  };

  render() {
    const { currentUser } = this.props;
    const { nowTabKey } = this.state;
    const { orgType, orgId } = currentUser;

    const listProps = {
      isDetail: false,
      request:
        orgType === "school" ? getSchoolSummaryList : getBureauSummaryList
    };
    const containerProps = {
      breStates: 1,
      isPathParams: true
    };

    const statisticAnalysisProps = {
      orgId,
      baseUrl: "6b996ffb52cd9f3eb833212ee4922518",
      activityBizId: this.activityBizId
    };

    const attendAnalysisProps = {
      baseUrl: "76844d970a482c91c06b0ea67afac0dc",
      activityBizId: this.activityBizId
    };

    return (
      <Container {...containerProps}>
        <Tabs onChange={this.handleChangeTab} activeKey={nowTabKey} type="card">
          <TabPane key="1" tab="统计分析">
            {nowTabKey === "1" && (
              <IframeContainer {...statisticAnalysisProps} />
            )}
          </TabPane>
          {orgType !== "school" && (
            <TabPane key="2" tab="参与分析">
              {nowTabKey === "2" && (
                <IframeContainer {...attendAnalysisProps} />
              )}
            </TabPane>
          )}
          <TabPane key="3" tab="统计明细">
            {nowTabKey === "3" && <SummaryStatisticList {...listProps} />}
          </TabPane>
        </Tabs>
      </Container>
    );
  }
}

export default index;
